//Header Text
export const SS_HEADER_TEXT = `Sliced Salame`;
export const SP_HEADER_TEXT = `Sliced Pepperoni`;
export const WC_HEADER_TEXT = `Whole Chubs`;

//Button text
export const BTN_SEE_MORE = `See More`;
export const BTN_SEE_LESS = `See Less`;
